module.exports = __webpack_public_path__ + "assets/img/d76ec66986ae2762a6b70ca35b8a6aba.png";